export default "__VITE_ASSET__cbab9d78__"